import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col } from "react-bootstrap";
import Lightbox from 'react-image-lightbox';
import { Helmet } from "react-helmet";
import { graphql } from 'gatsby'
import {isDesktop, isMobile, isTablet} from "react-device-detect";

import "../scss/property-details.scss";

import Breadcrumb from "../components/Breadcrumb/Breadcrumb"
import PropertyBanner from "../components/PropertyBanner/PropertyBanner"
import Layout from "../components/Layout"
import DetailsInfo from "../components/DetailsInfo/DetailsInfo"
import KeyFeatures from "../components/KeyFeatures/KeyFeatures"
import Contact from "../components/Contact/Contact"
import Map from "../components/MapInfo/Map"
import Calculator from "../components/Calculator/Calculator";
import Advice from "../components/Advice/Advice"
import Btn from "../components/BottomBtn/Btn"
import SellProperty from "../components/SellProperty/SellProperty"
import Journey from "../components/Journey/Journey";
import SimilarProperty from "../components/SimilarProperty/SimilarProperty";
import PlayVideo from "../modules/video_module/PlayVideo";
import { capitalize, lowerCase } from "lodash";
import { currencyFormat, getOffset } from "../common/utils/site_utlis"

import { PropertyDetails } from "../common/queries/common_use_query"
import NoPage from "../components/404_Page/404_Page"
import PreLoader from "../modules/pre-loader"
import { UserObjectStoreProvider, SaveItem, useUserObjectState, isAuthenticated } from "@starberry/myaccount-website-utils";
import { propertyDetailUrl } from "../common/utils/property_utils";

import { leadooPageSlot, hasMyaccount, SimilarProperty_FullWdth, slider_count } from "../common/constant";
import LeadooProperty from "../components/LeadooScript/LeadooProperty";
import { HeartIcon } from "../common/icons";
import ShareButton from "../components/DetailsInfo/ShareButton";
import PropertySidebarCard from "../components/PropertySidebarCard/PropertySidebarCard";

import FOMO from "../components/DetailsInfo/Fomo"


const PropertyDetailsTemplate = (props) => {

    const { state, services } = useUserObjectState()
    const authUser = isAuthenticated()
    const [stickyCls, setStickyCls] = useState(false);

    useEffect(() => {
        if (authUser && hasMyaccount) {
        // on page load get the users saved objects
            services.getUserobject({ type: "property", state:true })
        }

        // window.addEventListener("scroll", () => {
        //     if(window.scrollY > 1000){
        //         setStickyCls(true)
        //     } else{
        //         setStickyCls(false)
        //     }
            
        // })
    }, [])

    const [property_data, setPropertyData] = useState("");
    const [floorLightbox, setFloorLightbox] = useState([]);
    let [isPlay, setPlay] = useState(false);

    const whislist_item = typeof window !== 'undefined' && (localStorage.getItem('whislist_data') ? JSON.parse(localStorage.getItem('whislist_data')) : "");

    const [add_enquiry, setBulkEnquiry] = useState(whislist_item?.length > 0 ? whislist_item : []);

    const addEnquiry = () => {
        var property_details = {
                "id":property_data.id, 
                "crm_id":property_data.crm_id, 
                "title":property_data.title, 
                "department":property_data.department,
                "images":property_data.images,
                "imagetransforms":property_data.imagetransforms,
                "extra":property_data.extra,
                "office_crm_id":property_data.office_crm_id,
                "search_type":property_data.search_type,
                "status":property_data.status,
                "slug":property_data.slug,
                "officeDepartment":property_data.officeDepartment,
                "price_qualifier":property_data.price_qualifier,
                "price":property_data.price,
                "display_address":property_data.display_address,
                "bedroom":property_data.bedroom,
                "bathroom":property_data.bathroom,
                "council_tax":property_data.council_tax,
                "available_from":property_data.available_from,
                "description":property_data.description,
                "img_type": "no_property"
            }

        setBulkEnquiry([...add_enquiry, property_details])
    }

    const removeEnquiry = () => {
        var remove_property = add_enquiry.length > 0 && add_enquiry.filter(property => property.id !== property_data?.id)
        setBulkEnquiry(remove_property)
    }

    useEffect(() => {
        localStorage.setItem('whislist_data', JSON.stringify(add_enquiry));
    }, [add_enquiry])

    //console.log("add_enquiry", add_enquiry);
    //console.log("add_enquiry whislist", JSON.parse(localStorage.getItem('whislist_data')));

    //console.log("whislist_item", whislist_item)

    
    const siteName = process.env.GATSBY_SITE_NAME
    const pageurl = typeof window !== "undefined" ? window.location.href : ''
    let myid_filt = pageurl.split('?');
    let mypageurl = myid_filt[0];
    let property_slug = mypageurl.split('-');
    let id = property_slug[property_slug.length - 1];
    id = id.replace("/", "");

    //console.log("id ==>", id)

    const { loading, error, data } = PropertyDetails(id);

    //console.log("property_detail", props.data)

    useEffect(() => {
        if (data?.properties?.length > 0) {
            setPropertyData(data?.properties[0])
        }
    }, [data])

    //sticky
    const stickyRef = useRef();
    

    let videoUrl = "";
    if(typeof property_data?.video_tour === "object"){
        videoUrl = property_data?.video_tour?.length > 0 && property_data?.video_tour[0]?.url
    } else{
        videoUrl = property_data?.video_tour && property_data?.video_tour.url
    }



    let action = "for sale"
    if (property_data.search_type === "lettings") {
        action = "to rent"
    }
    let title = "Property"
    if (property_data?.building) {
        if(typeof property_data?.building === "object"){
            title = property_data?.building.length > 0 ? property_data?.building : title
        } else{
            title = property_data?.building
        }        
    }

    var bedroom_text = property_data?.bedroom ? (property_data?.bedroom > 1 ? "with "+property_data.bedroom+" bedrooms" : "with "+property_data.bedroom+" bedroom") : ""

    var metaTitle = `${capitalize(title)} ${action} ${bedroom_text} in ${property_data.display_address} at ${currencyFormat(property_data.price, '£', false)}`
    var metadecTitle = `${lowerCase(title)} ${action} ${bedroom_text} in ${property_data.display_address} at ${currencyFormat(property_data.price, '£', false)}`
    
    var metaDesc = `Know the details of ${metadecTitle}. Book a viewing with ${siteName} to get assistance in finding the right ${lowerCase(title)} for you.`

    let meta_data = { title: metaTitle, description: metaDesc }

    // Floorplan
    const [floorIndex, setFloorIndex] = useState(0);
    const [isFloorOpen, setIsFloorOpen] = useState(false);


    const clickFloorplan = (type) => {
        var fileNameFloor = type === "epc" ? property_data?.epc[0]?.url ? property_data?.epc[0]?.url : property_data?.epc[0]?.srcUrl : property_data?.floorplan[0]?.url ? property_data.floorplan[0].url : property_data?.floorplan[0]?.srcUrl;
        
        var fileextensionFloor = fileNameFloor.split('.').pop();

        const floorplanImages = type === "epc" ? property_data?.epc : property_data?.floorplan;
        if (floorplanImages.length > 0) {
            setFloorLightbox(floorplanImages.map(floorImg => floorImg.url ? floorImg.url : floorImg.srcUrl))
        }

        if (fileextensionFloor.toLowerCase() === "pdf") {
            window.open(fileNameFloor);
        } else {
            setIsFloorOpen(true);
        }
    }
    // Floorplan


    var searchParams = {"department": property_data?.department, "area":property_data?.area, "action": property_data?.search_type === "sales" ? "for sale" : "to rent", "search_type": property_data?.search_type}

    //console.log("globalModule", data?.globalModule);
    var department = property_data?.department ? property_data.department : "residential"
    var property_url = propertyDetailUrl(department, property_data?.search_type, property_data?.status, property_data?.slug, property_data?.id);

    var ldJson = `{
        "@context": "https://schema.org",
        "@graph": [	
            {
                "@type": "Place",
                "name": "${capitalize(property_data?.title)}  in ${property_data?.display_address}",
                "description": "${metaDesc}",
                "image": "${property_data?.images?.length > 0 && property_data?.images[0]?.url}",
                "address": {
                    "@type": "PostalAddress",
                    "streetAddress": "${property_data?.address?.address1}",
                    "addressLocality": "${property_data?.address?.address2}",
                    "postalCode": "${property_data?.address?.postcode}"
                }
            },
            {
                "@type": "Offer",
                "price": "${property_data?.price}",
                "priceCurrency": "pound",
                "url": "${process.env.GATSBY_SITE_URL+''+property_url}"
            }
       ]
    }`

    var office_depart = property_data?.office_crm_id ? property_data?.office_crm_id : "";

    var bulk_enquiry_status = add_enquiry.length > 0 && add_enquiry.filter(property => property.id === property_data?.id);

    //console.log("bulk_enquiry ==>", bulk_enquiry_status, property_data?.id, add_enquiry)

    return (
        <>
        {loading ? 
            <PreLoader />

        :
            <div className={`search-header property-header property_details`}>
                
                {data?.properties?.length > 0 ?
                    property_data.id &&
                    <Layout seo_meta={meta_data} isJourneySec={true} searchParams={searchParams} menu_slug="search_result" footerCls={(property_data.status === "For Sale" || property_data.status === "To Let") ? "" : "smal_pad"}>

                        <Helmet>
                            <script  type="application/ld+json">{ldJson}</script>
                        </Helmet>

                        { (process.env.GATSBY_SITE_NAME === "Brandvaughan" || process.env.GATSBY_SITE_NAME === "Michael Jones" || process.env.GATSBY_SITE_NAME === "Chase Evans" || process.env.GATSBY_SITE_NAME === "Charters") && <Breadcrumb property_data={property_data} location={props.location} />}

                        <PropertyBanner property_data={property_data} clickFloorplan={clickFloorplan} setPlay={setPlay} videoUrl={videoUrl} />

                        <div className="property_content">
                            <Container>
                                <Row>
                                    <Col className='d-flex'>
                                        <div className="lef_side">
                                            <DetailsInfo property_data={property_data} setPlay={setPlay} clickFloorplan={clickFloorplan} videoUrl={videoUrl} />

                                            <KeyFeatures property_data={property_data} globalModule={data?.globalModule}  />
                                            
                                            {/* {property_data?.crm_negotiator_id?.email && (
                                                <>
                                                    {
                                                        property_data?.status === "To Let" && data?.globalModule?.property_details?.show_nego_details && <Contact property_data={property_data} />
                                                    }
                                                    
                                                    {
                                                        property_data?.status == "For Sale" && <Contact property_data={property_data} />
                                                    }
                                                </>
                                            )} */}

                                            {(property_data.latitude && property_data.longitude) ?   
                                                <Map property_data={property_data} clickFloorplan={clickFloorplan} setPlay={setPlay} />
                                                : ''
                                            }

                                            {(isMobile || isTablet) && 
                                                (leadooPageSlot?.sell_property &&
                                                    <LeadooProperty property_data={property_data} search_type={leadooPageSlot[property_data?.search_type]}/>
                                                )
                                            }

                                            {(property_data.department === "residential" && property_data.status === "For Sale") &&
                                                <Calculator price={property_data?.price} department={property_data.department} officeDepartment={property_data.officeDepartment} />
                                            }


                                            { (property_data.department === "residential" && property_data.status === "For Sale") && data?.globalModule?.property_details?.show_speak_with_advisor && <Advice /> }

                                            {!SimilarProperty_FullWdth && 
                                                <SimilarProperty property_data={property_data} />
                                            }
                                        </div>


                                        <div className="right-box d-none d-xl-block" ref={stickyRef}>
                                            <div className='right-box-sticky'>
                                                {(property_data?.status === "For Sale" || property_data?.status === "To Let") &&
                                                <div className={`inner-wrap  ${stickyCls ? "is-sticked" : ""}`}>

                                                    {process.env.GATSBY_SITE_NAME === "BV Students" &&  
                                                        <FOMO crm_id={property_data.crm_id}/>
                                                    }

                                                    <Btn property_data={property_data} pageurl={pageurl} setPlay={setPlay} videoUrl={videoUrl} />

                                                    {office_depart && (office_depart.includes("LIS") || office_depart.includes("LSO") || office_depart.includes("LSQ")) && 
                                                        <div className='market_by'>
                                                            <img src={"https://ggfx-daleeddison.s3.eu-west-2.amazonaws.com/i.prod/logo_142bcac367.svg"} alt="" />
                                                            <span className='h4'>Marketed by <br />
                                                                <span className='sm-text'>Dale Eddison</span>
                                                            </span>
                                                        </div>
                                                    }

                                                    <div className="right-side-icons ">

                                                        <div className="icon-wrap sb-myacc-wrap">
                                                            <SaveItem type="property" pid={property_data?.id}>
                                                                <div class="detail-save">
                                                                    <HeartIcon /><span> Save</span><span class="saved-text">d</span>
                                                                </div>
                                                            </SaveItem>
                                                        </div>

                                                        <ShareButton property_data={property_data} className="share-icon" />
                                                    </div>

                                                    {/* {property_data?.crm_negotiator_id?.email && ( 
                                                        <>
                                                        {
                                                            property_data?.search_type === "lettings" && data?.globalModule?.property_details?.show_nego_details && <Contact property_data={property_data} />
                                                        }
                                                        
                                                        {
                                                            property_data?.search_type === "sales" && <Contact property_data={property_data} />
                                                        }
                                                        </>
                                                        )
                                                    } */}
                                                </div>
                                                }

                                                { (process.env.GATSBY_SITE_NAME === "Brandvaughan" || process.env.GATSBY_SITE_NAME === "Michael Jones" || process.env.GATSBY_SITE_NAME === "Chase Evans") &&<PropertySidebarCard /> }
                                                
                                                {process.env.GATSBY_SITE_NAME === "BV Students" && 
                                                    <section className={`sell-property-banner bulk_enquiry ${bulk_enquiry_status?.length > 0 ? "has_bulk_enq" : ""}`}>
                                                        <Container>
                                                            <Row>
                                                                <Col>
                                                                    <div className="sell-wrap">
                                                                        {bulk_enquiry_status?.length > 0 ? 
                                                                        <>
                                                                            <div className="h4">Remove this property from <a href="javascript:;" onClick={removeEnquiry}>Bulk Enquiry</a>
                                                                            </div>
                                                                            <i className="icon-hearteen" onClick={removeEnquiry}></i>
                                                                        </>
                                                                        :   
                                                                        <>
                                                                            <div className="h4">Add this property to <a href="javascript:;" onClick={addEnquiry}>Bulk Enquiry</a>
                                                                            </div>
                                                                            <i className="icon-hearteen" onClick={addEnquiry}></i>
                                                                        </>
                                                                        }                    
                                                                    </div>

                                                                </Col>
                                                            </Row>
                                                        </Container>
                                                    </section>
                                                }

                                                {(process.env.GATSBY_SITE_NAME  !== "Beals" && isDesktop) &&
                                                    (leadooPageSlot[property_data?.search_type]) && (
                                                        <LeadooProperty property_data={property_data} search_type={leadooPageSlot[property_data?.search_type]}/>
                                                    
                                                    )
                                                }

                                                {/* {
                                                    property_data?.search_type == "sales" && <SellProperty />
                                                }

                                                {
                                                    data?.globalModule?.property_details?.show_sell_your_property && property_data?.search_type === "lettings" && <SellProperty />
                                                } */}

                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </Container>
                        </div>
                        
                        {SimilarProperty_FullWdth && 
                            <div className='similar_section'>
                                <Container>
                                    <SimilarProperty property_data={property_data} slider_count={slider_count} />
                                </Container>
                            </div>    
                        }         

                        <Journey />
                        
                        {(property_data.status === "For Sale" || property_data.status === "To Let") &&
                            <Btn property_data={property_data} pageurl={pageurl} setPlay={setPlay} videoUrl={videoUrl}  />
                        }

                        <PlayVideo
                            isOpen={isPlay}
                            isCloseFunction={setPlay}
                            videoUrl={videoUrl}
                            isAutoPlay={1}
                        />

                        {isFloorOpen && (
                            <Lightbox
                                mainSrc={floorLightbox[floorIndex]}
                                nextSrc={floorLightbox.length > 1 ? floorLightbox[(floorIndex + 1) % floorLightbox.length] : false}
                                prevSrc={floorLightbox.length > 1 ? floorLightbox[(floorIndex + floorLightbox.length - 1) % floorLightbox.length] : false}
                                onCloseRequest={() => setIsFloorOpen(false)}
                                onMovePrevRequest={() =>
                                    setFloorIndex((floorIndex + floorLightbox.length - 1) % floorLightbox.length)
                                }
                                onMoveNextRequest={() =>
                                    setFloorIndex((floorIndex + 1) % floorLightbox.length)
                                }
                            />
                        )}
                    </Layout>
                    :
                    <NoPage />
                }
            </div>
        }
        </>

    )

}

const PropertyDetailsWrap = (props) => {
    return (
      <UserObjectStoreProvider>
        <PropertyDetailsTemplate {...props} />
      </UserObjectStoreProvider>
    )
}

export default PropertyDetailsWrap;

// export const query = graphql`
//   query ($strapi_id: String) {
//     strapiProperty(strapiId: {eq: $strapi_id}) {
//         strapiId
//         id
//         accomadation_summary
//         crm_id
//         office_crm_id
//         status
//         floorarea_max
//         floorarea_min
//         floorarea_type
//         search_type
//         department
//         address {
//             building_name
//             building_number
//             address1
//             address2
//             address3
//             address4
//             postcode
//         }
//         area
//         display_address
//         title
//         slug
//         price
//         reception
//         bedroom
//         bathroom
//         images {
//             srcUrl
//             order
//             url
//         }
//         imagetransforms {
//             images_Transforms
//         }
//         crm_negotiator_id {
//             id
//         }
//         description
//         long_description
//         latitude
//         longitude
//         extra {
//             created
//             modified
//         }
//         brochure
//         price_qualifier
//         parking
//         letting_info {
//             instructed
//             availableFrom
//             agreementSigned
//             rent
//             rentFrequency
//             term
//             status
//             agentRole
//             landlordId
//             minimumTerm
//             qualifier
//         }
//         council_tax
//         selling_info {
//             instructed
//             price
//             reservationFee
//             qualifier
//             status
//             disposal
//             completed
//             exchanged
//             accountPaid
//             vendorId
//             agency
//             agencyId
//             exchangedCompanyFee
//             recommendedPrice
//             valuationPrice
//             brochureId
//             publicBrochureUrl
//             exchangedPrice
//             exchangedOfficeId
//         }
//     }
// }`
